import Icon from '../../components/Icon.vue'

Icon.register({"brands/bimobject":{"width":448,"height":512,"paths":[{"d":"M416 32H32C14.4 32 0 46.4 0 64V448C0 465.6 14.4 480 32 480H416C433.6 480 448 465.6 448 448V64C448 46.4 433.6 32 416 32zM352 289.4C352 338.8 340.6 372 248.2 372H231.3C187.2 372 168.9 357.1 160.9 333.2H160V368H96V136H160V210.7H161.1C165.7 180.2 200.8 171.9 230.8 171.9H248.1C340.5 171.9 351.9 205 351.9 254.4V289.4zM288 260.5V283.4C288 305.1 284.6 317.2 249.6 317.2H204.3C175.4 317.2 160.2 310.7 160.2 281.5V262.5C160.2 233.2 175.4 226.8 204.3 226.8H249.6C284.6 226.6 288 238.8 288 260.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/bimobject.js
// module id = null
// module chunks = 